
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/widget",
      function () {
        return require("private-next-pages/widget.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/widget"])
      });
    }
  